'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getExpandIds = exports.genDefaultExpandIds = exports.genLiteNodeTree = exports.genNodeTree = exports.treeNodeStruct = exports.defaultFieldNames = exports.INDETERMINATE = exports.UNCHECKED = exports.CHECKED = undefined;

var _index = require('../type/index');

var _index2 = require('../object/index');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * 树状选择器 data 生成 NodeTree 工具
                                                                                                                                                                                                     * @author 作者: laynezhou
                                                                                                                                                                                                     * @copyright laynezhou@tencent.com
                                                                                                                                                                                                     * @version 版本 2017/12/28
                                                                                                                                                                                                     */

/**
 * 节点选中状态
 * @type {string}
 */
var CHECKED = exports.CHECKED = 'checked';
var UNCHECKED = exports.UNCHECKED = 'unchecked';
var INDETERMINATE = exports.INDETERMINATE = 'indeterminate';

/**
 * 默认数据结构的字段映射
 * @type {{labelFieldName: string, titleFieldName: string, nodeFieldName: string, disabledFieldName: string}}
 */
var defaultFieldNames = exports.defaultFieldNames = {
    labelFieldName: 'desc',
    titleFieldName: 'tips',
    nodeFieldName: 'options',
    disabledFieldName: 'disabled'
};

/**
 * 一个数据树的节点数据结构
 */
var treeNodeStruct = exports.treeNodeStruct = {
    // 作为数据节点的唯一标识, 如果原始数据有value, 则设为value的值
    key: null,
    // 在同级节点中的排序
    siblingIndex: null,
    // 节点的的value
    value: null,
    // 节点的展示文案
    desc: null,
    // 指向原始数据节点的指针
    sourceData: null,
    // 指向父节点的指针
    parentNode: null,
    // 孩子节点数组,里面是一个个treeNodeStruct的指针
    childrenNodes: null,
    // 节点的 check 状态: checked/unchecked/indeterminate
    status: null,
    // 节点是否展开子节点
    isExpand: null,
    // 节点在处在第几个branch, 最左branch为1, 往右递增
    deepLevel: null,
    // 是否展示loading状态
    isLoading: null
};

/**
 *  递归更新父节点链中 Node.status为 checked/unchecked/indeterminate 状态
 * @param parentNode
 * @param status
 * @returns {boolean}
 */
var updateParentStatus = function updateParentStatus(parentNode, status) {
    if (!parentNode) {
        return false;
    }
    if (status === CHECKED && parentNode.status === UNCHECKED) {
        parentNode.status = CHECKED;
        updateParentStatus(parentNode.parentNode, INDETERMINATE);
    } else if (status === INDETERMINATE && parentNode.status === UNCHECKED) {
        parentNode.status = INDETERMINATE;
        updateParentStatus(parentNode.parentNode, INDETERMINATE);
    }
};

/**
 * 遍历树状数据的递归器
 * @param data
 * @param parentNode
 * @param genOneTreeNode 该方法需要返回children的数组
 * @returns {null}
 */
var traverseTree = function traverseTree(data, parentNode, genOneTreeNode) {
    if (!data || data.length <= 0) {
        return null;
    }
    data.forEach(function (item, index) {
        var currentNode = (0, _index2.objectAssign)({}, treeNodeStruct, item);
        // 保存一份元数据
        currentNode.sourceData = item;
        currentNode.deepLevel = (parentNode.deepLevel || 0) + 1;

        // 在同级节点中的排序
        currentNode.siblingIndex = index;

        // 设置一下key, 一般使用value的值, 如果没有Value, 就给一个默认的
        currentNode.key = item.value || typeof item.value === 'number' ? item.value : parentNode && parentNode.key ? parentNode + '_' + index : index;

        // 更新一下当前节点的 父节点 子节点
        currentNode.parentNode = parentNode;
        if (parentNode.childrenNodes) {
            parentNode.childrenNodes.push(currentNode);
        } else {
            parentNode.childrenNodes = [currentNode];
        }
        var childrenData = genOneTreeNode(currentNode);
        traverseTree(childrenData, currentNode, genOneTreeNode);
    });
};

/**
 * 递归遍历 props.data 生成NodeTree
 * NodeTree: 存储了整个树状的数据(树节点的结构以 treeNodeStruct 为模板)
 * 在这个方法中, 完成了从 最原始的树状数据 prop.data 到 NodeTree的转化
 * 必须得遍历整棵树, 不然一些节点的半选状态无法确定
 * @param props
 * @returns {rootTreeNode}
 */
var genNodeTree = exports.genNodeTree = function genNodeTree(props) {
    var data = props.data,
        propsValue = props.value,
        expandNodeIds = props.expandNodeIds,
        loadingIds = props.loadingIds,
        fieldNames = props.fieldNames,
        valueType = props.valueType,
        isAutoCheckedParent = props.isAutoCheckedParent,
        _props$multiple = props.multiple,
        multiple = _props$multiple === undefined ? true : _props$multiple;

    var _ref = fieldNames || defaultFieldNames,
        nodeFieldName = _ref.nodeFieldName;

    var checkedIds = propsValue;
    var showColumnsCount = 1;
    var treeDeep = 0;
    var valueTreeNodeMap = {};

    // 非多选的时候，如果value不是数组就需要转化下
    if (!multiple && !(0, _index.isArray)(checkedIds)) {
        checkedIds = [checkedIds];
    }

    // 把 checkedIds, loadingIds  转换为一个 {value: true||false}的哈希结构
    // 哈希读取比数组indexOf性能更好, 性能是O(1)
    var checkedIdsMap = checkedIds && checkedIds.reduce(function (pre, item) {
        pre[item] = true;
        return pre;
    }, {}) || {};

    var loadingIdsMap = loadingIds && loadingIds.reduce(function (pre, item) {
        pre[item] = true;
        return pre;
    }, {}) || {};

    var genOneTreeNode = function genOneTreeNode(currentNode) {
        var parentNode = currentNode.parentNode;
        treeDeep = currentNode.deepLevel > treeDeep ? currentNode.deepLevel : treeDeep;
        // 如果父节点是选中的话, 那么子节点都显示为checked
        if (parentNode.status === CHECKED) {
            currentNode.status = CHECKED;
        } else {
            currentNode.status = checkedIdsMap[currentNode.key] ? CHECKED : UNCHECKED;
            // 如果当前节点是选中的, 那么递归更新一下父节点链的状态
            if (currentNode.status === CHECKED && parentNode) {
                updateParentStatus(parentNode, INDETERMINATE);
            }
        }
        // 更新节点的是否处于loading的状态
        if (loadingIdsMap[currentNode.key]) {
            currentNode.isLoading = true;
        }
        // 需要校验isExpandId的值是否在一条树枝上
        if (expandNodeIds && (showColumnsCount === 1 || showColumnsCount > 1 && parentNode.key === expandNodeIds[showColumnsCount - 2])) {
            // 如果当前节点有子节点且展开, showColumnsCount + 1
            if (expandNodeIds[showColumnsCount - 1] === currentNode.key && currentNode[nodeFieldName] && currentNode[nodeFieldName].length > 0) {
                currentNode.isExpand = true;
                showColumnsCount += 1;
            }
        }
        valueTreeNodeMap[currentNode.key] = currentNode;
        return currentNode[nodeFieldName];
    };

    // 这是一个虚拟的顶层的节点, 不展示, 辅助作为root节点
    var rootTreeNode = (0, _index2.objectAssign)({}, treeNodeStruct);

    // 开始对props.data做递归遍历, 从根节点开始, 构建节点树
    traverseTree(data, rootTreeNode, genOneTreeNode);

    // 如果返回的数据是最末的节点的话，全选中子节点的话，也要选中父节点，不然没法一次性取消子节点
    if (valueType === 'child' || isAutoCheckedParent) {
        // 从子节点往上找
        var key = '',
            item = {},
            childrenNodes = [];

        var checkNodeIsChecked = function checkNodeIsChecked() {
            var itemData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var parentId = itemData.parent_id || '';
            var parentData = {},
                isAllChecked = true;

            if (parentId) {
                parentData = valueTreeNodeMap[parentId] || null;

                if (parentData) {
                    childrenNodes = parentData.childrenNodes || [];

                    if (childrenNodes.length > 0) {
                        childrenNodes.map(function (childrenItem) {
                            if (isAllChecked && childrenItem.status !== CHECKED) {
                                isAllChecked = false;
                            }

                            return childrenItem;
                        });

                        if (isAllChecked) {
                            parentData.status = CHECKED;
                            checkedIdsMap[parentData.value] = true;
                            checkNodeIsChecked(parentData);
                        }
                    }
                }
            }
        };

        for (key in valueTreeNodeMap) {
            if (key) {
                item = valueTreeNodeMap[key] || {};
                childrenNodes = item.childrenNodes || [];

                if (childrenNodes.length < 1) {
                    checkNodeIsChecked(item);
                }
            }
        }
    }

    return {
        rootTreeNode: rootTreeNode,
        valueTreeNodeMap: valueTreeNodeMap,
        showColumnsCount: showColumnsCount,
        treeDeep: treeDeep,
        checkedIdsMap: checkedIdsMap,
        loadingIdsMap: loadingIdsMap
    };
};

/**
 * 生成一个轻量的NodeTree
 * @param data
 * @param valueTreeNodeMap
 * @param rootTreeNode 该参数决定当前数据的挂载点
 * @param config
 * @returns {*}
 */
var genLiteNodeTree = exports.genLiteNodeTree = function genLiteNodeTree(data) {
    var valueTreeNodeMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var theRootTreeNode = arguments[2];
    var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var _ref2 = config.fieldNames || defaultFieldNames,
        nodeFieldName = _ref2.nodeFieldName;

    var rootTreeNode = theRootTreeNode;

    // 没有传入rootTreeNode就自动生成一个虚拟的父节点
    if (!rootTreeNode) {
        rootTreeNode = (0, _index2.objectAssign)({}, treeNodeStruct);
    }
    // 如果用户传入 rootTreeNode, 把数据挂在到这个节点的源数据上去
    if (rootTreeNode.sourceData) {
        rootTreeNode.sourceData[nodeFieldName] = data;
    }
    var genOneTreeNode = function genOneTreeNode(currentNode) {
        valueTreeNodeMap[currentNode.key] = currentNode;
        return currentNode[nodeFieldName];
    };
    traverseTree(data, rootTreeNode, genOneTreeNode);
    return {
        valueTreeNodeMap: valueTreeNodeMap,
        rootTreeNode: rootTreeNode
    };
};

/**
 * 生成默认的展开列表: ExpandIds
 * @param valueTreeNodeMap
 * @param checkedIds 当前用户选择的值列表
 * @returns expandNodeIds
 */
var genDefaultExpandIds = exports.genDefaultExpandIds = function genDefaultExpandIds() {
    var valueTreeNodeMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var checkedIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var expandNodeIds = [];
    try {
        // 获取祖先列表比如 [[0, 71000], [1, 234232, 23434], [1, 2343, 23432]]
        var checkedIdAncestorList = checkedIds && checkedIds.map(function (item) {
            var ancestorList = [];
            var currentNode = valueTreeNodeMap[item];
            while (currentNode) {
                if (currentNode.key !== null) {
                    ancestorList.unshift({ key: currentNode.key, siblingIndex: currentNode.siblingIndex });
                }
                currentNode = currentNode.parentNode;
            }
            return ancestorList;
        });
        // 设置一下最生成最大的expandIds的长度, 太长没有必要, 而且浪费cpu计算能力
        var maxExpandDeep = 10;
        var index = 0;
        var leavecheckedIdAncestorList = [].concat(_toConsumableArray(checkedIdAncestorList));
        while (index < maxExpandDeep) {
            var sourceList = [].concat(_toConsumableArray(leavecheckedIdAncestorList));
            if (sourceList.length < 1) {
                break;
            } else if (sourceList.length === 1) {
                expandNodeIds = sourceList[0] && sourceList[0].map(function (item) {
                    return item.key;
                });
                break;
            }
            var tempIndex = -1;
            for (var i = 0; i < sourceList.length; i++) {
                if (checkedIdAncestorList[i][index]) {
                    var currentIndex = checkedIdAncestorList[i][index]['siblingIndex'];
                    if (tempIndex === -1) {
                        tempIndex = currentIndex;
                        leavecheckedIdAncestorList = [checkedIdAncestorList[i]];
                    } else if (currentIndex < tempIndex) {
                        tempIndex = currentIndex;
                        leavecheckedIdAncestorList = [checkedIdAncestorList[i]];
                    } else if (currentIndex === tempIndex) {
                        leavecheckedIdAncestorList.push(checkedIdAncestorList[i]);
                    }
                }
            }
            index += 1;
        }
    } catch (e) {
        expandNodeIds = [];
    }
    return expandNodeIds;
};

// 根据原始数据以及选中的数据来获取展开的数据
var getExpandIds = exports.getExpandIds = function getExpandIds() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var result = [],
        theValue = [];

    if (!(0, _index.isArray)(value)) {
        theValue = [value];
    } else {
        theValue = value;
    }

    result = genDefaultExpandIds(genLiteNodeTree(data).valueTreeNodeMap, theValue);

    return result;
};

exports.default = {
    genNodeTree: genNodeTree,
    genLiteNodeTree: genLiteNodeTree,
    genDefaultExpandIds: genDefaultExpandIds,
    getExpandIds: getExpandIds,
    treeNodeStruct: treeNodeStruct,
    CHECKED: CHECKED,
    UNCHECKED: UNCHECKED,
    INDETERMINATE: INDETERMINATE,
    defaultFieldNames: defaultFieldNames
};